import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import scrollIntoView from 'scroll-into-view'
import { LoadingLine } from 'components/Layout/LoadingLine'
import { ArchiveIcon } from 'components/Utils/Icons'

export default function Row({
  entry,
  onClick,
  isHighlighted,
  isActiveNote,
  onMouseMove,
}) {
  const elementRef = React.useRef()
  // hover state is used to disabled auto scroll
  const [hovered, setHovered] = React.useState(false)
  React.useEffect(
    () => {
      if (isHighlighted && !hovered) {
        scrollIntoView(elementRef.current, { time: 0, behavior: 'smooth' })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isHighlighted]
  )

  const snippets = entry.data._snippetResult
  const titleHTML =
    (snippets.title && snippets.title.value.trim()) || 'Untitled'
  const contentHTML =
    (snippets.content && snippets.content.value.trim()) || 'Empty doc'

  return (
    <Link
      onMouseMove={event => {
        setHovered(true)
        if (!hovered) {
          onMouseMove(event)
        }
      }}
      onMouseOut={() => {
        setHovered(false)
      }}
      ref={elementRef}
      className={classNames(
        'block pointer padding-vertical-large padding-horizontal-medium',
        {
          'background-shade-50-on-hover background-shade-50-on-focus shade-10':
            !isActiveNote && !isHighlighted,
          'background-shade-45 shade-05': isActiveNote,
          'background-shade-50 shade-05': !isActiveNote && isHighlighted,
        }
      )}
      onClick={onClick}
    >
      <div className="flexbox margin-bottom-small">
        <div
          className="note-title ellipsis"
          style={{ fontSize: 15 }}
          dangerouslySetInnerHTML={{ __html: titleHTML }}
        />
        {entry.data.isArchived && (
          <div className="margin-left-small">
            <ArchiveIcon />
          </div>
        )}
      </div>
      <div
        className="line-height-large font-size-large"
        dangerouslySetInnerHTML={{ __html: contentHTML }}
      />
    </Link>
  )
}

export function Loading() {
  return (
    <div className="padding-large">
      <LoadingLine animationDelay={1} lineWidth="40%" marginBottom={30} />
      <LoadingLine animationDelay={1} lineWidth="90%" />
      <LoadingLine animationDelay={1} lineWidth="80%" />
    </div>
  )
}
